import { useForm } from "react-hook-form";
import {
  forgottenPasswordFormDefaultValues,
  forgottenPasswordFormSchema,
  IForgottenPasswordFormModel,
} from "../models/forgottenPasswordFormModel";
import { yupResolver } from "@hookform/resolvers/yup";

export const useForgottenPasswordForm = () => {
  const form = useForm<IForgottenPasswordFormModel>({
    defaultValues: forgottenPasswordFormDefaultValues,
    resolver: yupResolver(forgottenPasswordFormSchema),
  });

  return form;
};
